import React from 'react';
import { NavalLensPage } from './pages/NavalLensPage';
export function App() {
  return <NavalLensPage data-id="element-0" />;
}